import { BookingFragment } from "src/state/gql/_types"
import { FormSchema } from "src/utils/forms"

export type SuperAdminVenueBookingCreateFragment = Omit<BookingFragment, 'id' | 'status' | 'created_at' | 'updated_at' | 'created_by_user' | 'updated_by_user' | 'booking_status' | 'series_id' | 'recurring' | 'is_master' | 'series' | 'booking_rate_type' | 'booking_invoice_target' | 'booking_type' | 'guidelines'>

export const SuperAdminVenueBookingCreateSchema: FormSchema<SuperAdminVenueBookingCreateFragment> = {
    id: "booking",
    title: "Booking",
    groups: {
        default: {
            label: 'Default' 
        }
    },
    fields: {
        type: {
            group: 'default',
            label: "Booking Type",
            type: "booking-type-enum",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        area_id: {
            group: 'default',
            label: "Area",
            type: "venue-area-select",
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        talent_id: {
            group: 'default',
            label: "Talent",
            type: "superadmin-booking-talent-select",
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        date: {
            group: 'default',
            label: "Date",
            type: "date-picker",
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        event_start_time: {
            group: 'default',
            label: "Event Start Time",
            type: "time-picker",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        event_end_time: {
            group: 'default',
            label: "Event End Time",
            type: "time-picker",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        set_start_time: {
            group: 'default',
            label: "Set Start Time",
            type: "time-picker",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        set_end_time: {
            group: 'default',
            label: "Set End Time",
            type: "time-picker",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        rate: {
            group: 'default',
            label: "Rate",
            type: "currency",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        rate_type: {
            group: 'default',
            label: "Rate Type",
            type: "booking-rate-type-enum",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        rate_margin: {
            group: 'default',
            label: "Rate Margin",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        invoice_target: {
            group: 'default',
            label: "Invoice Target",
            type: "booking-invoice-target-enum",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        poc: {
            group: 'default',
            label: "Point of Contact",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        notes: {
            group: 'default',
            label: "Notes",
            type: "textarea",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
    }
}

export type SuperAdminVenueBookingUpdateFragment = Omit<BookingFragment, 'id' | 'created_at' | 'updated_at' | 'created_by_user' | 'updated_by_user' | 'booking_status' | 'series_id' | 'recurring' | 'is_master' | 'series' | 'booking_rate_type' | 'booking_invoice_target' | 'booking_type' | 'guidelines'>

export const SuperAdminVenueBookingUpdateSchema: FormSchema<SuperAdminVenueBookingUpdateFragment> = {
    id: "booking",
    title: "Booking",
    groups: {
        default: {
            label: 'Default' 
        }
    },
    fields: {
        type: {
            group: 'default',
            label: "Booking Type",
            type: "booking-type-enum",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        status: {
            group: 'default',
            label: "Status",
            type: "superadmin-booking-status-enum",
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        area_id: {
            group: 'default',
            label: "Area",
            type: "venue-area-select",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        talent_id: {
            group: 'default',
            label: "Talent",
            type: "superadmin-booking-talent-select",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        date: {
            group: 'default',
            label: "Date",
            type: "date-picker",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        event_start_time: {
            group: 'default',
            label: "Event Start Time",
            type: "time-picker",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        event_end_time: {
            group: 'default',
            label: "Event End Time",
            type: "time-picker",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        set_start_time: {
            group: 'default',
            label: "Set Start Time",
            type: "time-picker",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        set_end_time: {
            group: 'default',
            label: "Set End Time",
            type: "time-picker",
            grid: 6,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        rate: {
            group: 'default',
            label: "Rate",
            type: "currency",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        rate_type: {
            group: 'default',
            label: "Rate Type",
            type: "booking-rate-type-enum",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        rate_margin: {
            group: 'default',
            label: "Rate Margin",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        invoice_target: {
            group: 'default',
            label: "Invoice Target",
            type: "booking-invoice-target-enum",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        poc: {
            group: 'default',
            label: "Point of Contact",
            type: "text",
            grid: 4,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
        notes: {
            group: 'default',
            label: "Notes",
            type: "textarea",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        },
    }
}